import React from 'react';
import './AboutPage.scss';

function AboutPage() {
  return (
    <section className='container text-center p-3 about'>
      <h2>
        Despre Platforma Implicare Civica
      </h2>
      <p>
        Platforma Implicare Civica este dedicată conectării oamenilor cu inițiativele civice
        din comunitățile lor. Misiunea noastră este de a încuraja participarea activă a cetățenilor
        în proiecte care promovează schimbarea pozitivă. Fie că este vorba despre voluntariat,
        educație, sau susținerea cauzelor importante, platforma noastră îți oferă oportunitatea
        de a face o diferență.
      </p>
      <p>
        Ne dorim să construim o comunitate mai puternică prin transparență, colaborare și
        inovație. Alătură-te nouă în această călătorie pentru a crea un viitor mai bun pentru toți.
      </p>

      <p className='mt-4'>
        Pentru mai multe informații, contactați echipa noastră 
        la <a href="mailto:asociatiatineriliberi@gmail.com">asociatiatineriliberi@gmail.com</a> sau 
        pe retelele noastre sociale de <a href="https://www.instagram.com/tineriliberi/">Instagram</a> si <a href="https://www.facebook.com/InitiativaTimisoara/">Facebook</a>.
      </p>
    </section>
  );
}

export default AboutPage;
